import { render } from "./MetaMaskInfo.vue?vue&type=template&id=451f1356&scoped=true"
import script from "./MetaMaskInfo.vue?vue&type=script&lang=js"
export * from "./MetaMaskInfo.vue?vue&type=script&lang=js"

import "./MetaMaskInfo.vue?vue&type=style&index=0&id=451f1356&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451f1356"]])

export default __exports__